import { supabase } from '@/integrations/supabase/client';

type AnyFrom = { from: (name: string) => any };
type AnyRpc = { rpc: (name: string, args?: Record<string, unknown>) => any };

export function usersTable() {
  return (supabase as unknown as AnyFrom).from('users');
}

export function userProfilesTable() {
  return (supabase as unknown as AnyFrom).from('user_profiles');
}

export function subscriptionsTable() {
  return (supabase as unknown as AnyFrom).from('subscriptions');
}

export function emailLogsTable() {
  return (supabase as unknown as AnyFrom).from('email_logs');
}

export function userUnsubscribeTokensTable() {
  return (supabase as unknown as AnyFrom).from('user_unsubscribe_tokens');
}

export function rpcCompat(name: string, args?: Record<string, unknown>) {
  return (supabase as unknown as AnyRpc).rpc(name, args);
}


